
import DataGrid from 'components/DataGrid';
import { Grid } from '@mui/material';
import { BtnSearch, BtnClear } from 'components/Button/ButtonAll';
import { FormProvider } from 'react-hook-form';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { useFundAccouting } from './useFundAccouting';
import RenderCellPopoverUpdate from '../Ticket/components/RenderCellPopoverUpdate';

const FundAccoutingList = () => {

    const {
        isPermission,
        formSearch,
        dataColumn,
        getTable,
        onDelete,
        handleClearSearch,
        dataRow,
        loadingTable,
        anchorEl,
        setAnchorEl,
        messagePopper,
    } = useFundAccouting()

    return (
        <Grid container spacing={1} justifyContent={'flex-start'}>
            <Grid item xs={12} >
                <FormProvider {...formSearch}>
                    <Grid container spacing={2} justifyContent={"flex-end"} alignItems={"start"}>
                        <Grid item xs={6} sm={4} md={3}>
                            <DatePickerItem
                                id={`dDate`}
                                name={`dDate`}
                                label={`ประจำเดือน-ปี`}
                                required={false}
                                fullWidth
                                IsMonthYearPicker
                                format="MMMM YYYY"
                            />
                        </Grid>
                        <Grid item xs={'auto'}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item>
                                    <BtnClear id={"btn-clear"} IsCircleWithOutText onClick={() => handleClearSearch()} />
                                </Grid>
                                <Grid item>
                                    <BtnSearch id={"btn-search"} IsCircleWithOutText onClick={() => getTable(dataRow)} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item xs={12} >
                <DataGrid
                    columns={dataColumn}
                    isShowCheckBox={isPermission}
                    rows={dataRow}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isHiddenFooter={dataRow.arrRows.length === 0}
                    onDelete={onDelete}
                    sTableID='tbFundAcc'
                    isHiddenToolHead={true}
                />
            </Grid>
            <RenderCellPopoverUpdate
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                MessagePopper={messagePopper}
            />
        </Grid>

    )
}

export default FundAccoutingList
